import { CKB } from '@did/constants/chain'
import { BaseListItem } from '@did/das-balance-components'
import { ACTION_TYPE } from '@did/constants'
import { ITrxHistoryListInfo } from '@did/das-balance-types'
import { formatDateTime, fromSatoshi, thousandSplit } from '@did/tools'
import React from 'react'
import styles from './history-item.module.scss'
import TrxAction from './trx-action'
import { useDasBalanceContext } from '@did/das-app-context'
import { Iconfont } from '@did/uikit'

const getSymbol = (action: number) => {
  if (
    [
      ACTION_TYPE.withdraw,
      ACTION_TYPE.list,
      ACTION_TYPE.buyAccount,
      ACTION_TYPE.dasBalanceRegisterOrRenew,
      ACTION_TYPE.renewal,
      ACTION_TYPE.setReverseRecord,
      ACTION_TYPE.makeOffer,
      ACTION_TYPE.editOfferAdd,
      ACTION_TYPE.offerAccepted,
      ACTION_TYPE.enableSubAccount,
      ACTION_TYPE.createSubAccount,
      ACTION_TYPE.subAccountRenew
    ].includes(action)
  ) {
    return '-'
  } else if (
    [
      ACTION_TYPE.mergeRewards,
      ACTION_TYPE.delist,
      ACTION_TYPE.sellAccount,
      ACTION_TYPE.transferToTransit,
      ACTION_TYPE.delReverseRecord,
      ACTION_TYPE.refundOfDeposit,
      ACTION_TYPE.cancelOffer,
      ACTION_TYPE.acceptOffer,
      ACTION_TYPE.editOfferSub,
      ACTION_TYPE.orderRefund,
      ACTION_TYPE.accountRecycled,
      ACTION_TYPE.accountRecycledCrossRefund,
      ACTION_TYPE.accountRecycledRefund,
      ACTION_TYPE.subAccountProfit,
      ACTION_TYPE.accountAuctionRefund
    ].includes(action)
  ) {
    return '+'
  }
}

interface HistoryItemProps {
  account: ITrxHistoryListInfo
}

export const HistoryItem: React.FC<HistoryItemProps> = ({ account }) => {
  const { isProd } = useDasBalanceContext()

  const goTrxInfo = () => {
    window.open(`${CKB.getExplorerTrx(isProd)}${account.hash}`)
  }

  return (
    <BaseListItem
      className={styles.historyItem}
      onClick={goTrxInfo}
      head={
        <div className={styles.historyItem__header}>
          <span className={styles.historyItem__header__priceCkb}>
            <span
              className={
                getSymbol(account.action) === '+'
                  ? styles.historyItem__header__actionReceipt
                  : styles.historyItem__header__actionPay
              }
            >
              {getSymbol(account.action) +
                ' ' +
                thousandSplit(fromSatoshi(account.capacity)) +
                ' CKB'}
            </span>
            <Iconfont name="arrow-right" color="#ACB9D9" size="13" />
          </span>
          <span className={styles.historyItem__header__timestamp}>
            {formatDateTime(account.timestamp)}
          </span>
        </div>
      }
      tail={<TrxAction account={account} />}
    />
  )
}
